import { queryClient } from "@/queryClient";
import { refreshShareAuthMirror } from "./shareAuthMirror";

/**
 * Everything that has to happen when the signed-in org/account changes without
 * the page reloading — i.e. a native "Switch organization", which finishes in
 * place via `handleRedirectCallback` in `NativeAppUrlListener`.
 *
 * On web the same switch is a full document load, so all of this comes free:
 * fresh module state, an empty in-memory query cache, and
 * `QueryCacheIdentityGuard` re-running against the new token. Native gets none
 * of it, so the work is done explicitly here.
 *
 * Call this only once the token exchange has resolved — everything below reads
 * the new token, and running it early re-reads the old one.
 */
export function handleNativeAuthIdentityChange(): void {
  // The Share Extension uploads with the mirrored token, so it has to learn
  // about the switch or shares keep landing in the previous org.
  refreshShareAuthMirror();

  // `/me` is org-scoped, and nothing on this path invalidates it: the query
  // stays mounted, and the window-focus refetch triggered by the Auth0 browser
  // sheet dismissing runs *before* the exchange lands, so it can even rewrite
  // the outgoing org's data and reset its staleness clock. Left alone, the app
  // names the previous org until something else happens to refetch — and the
  // share sheet's identity line stays hidden, because the labels can't be
  // matched against the new token's claims.
  void queryClient.invalidateQueries({ queryKey: ["userInfo"] });
}
